// The day's windows: the day itself, the event form and the form's description on its own.

// A press on these doesn't move a window: they're for picking, typing and the day's own dragging.
export const WINDOW_CANCEL = '.day-layout-events, .text-editor, .event-description, .category, .thematics-form-block, .date-field, .event-layout';

// As tall as the day window was before windows could be resized.
const windowHeight = () => Math.min(Math.round(window.innerHeight * 0.87), 768);

// The sizes they open at until resized, which they remember, and the smallest they can be.
export const dayWindowSize = () => ({
    width: window.innerWidth > 1560 ? 932 : window.innerWidth > 1300 ? 700 : 600,
    height: windowHeight(),
});
export const DAY_WINDOW_MIN = { width: 420, height: 360 };

export const formWindowSize = () => ({ width: 616, height: windowHeight() });
export const FORM_WINDOW_MIN = { width: 460, height: 480 };

export const descriptionWindowSize = () => ({ width: 560, height: windowHeight() });
export const DESCRIPTION_WINDOW_MIN = { width: 320, height: 240 };
